export enum SchedulePosition {
  Now = 1, // Play right away
  Next, // Play next
  End, // Add to the end of the queue
}

export interface SchedulerInterface<T> {
  /**
   * Has Items to Play
   * @returns {boolean} - Returns true if their are tracks to play
   */
  hasItemsToPlay(): boolean;

  /**
   * Needs Items to Play
   * @returns {boolean} - Returns true if we need to feed the scheduler
   */
  needsItemsToPlay(): boolean;

  /**
   * Clear Unplayed
   * Clears all the unplayed tracks from the current position to the end of the schedule
   */
  clearUnplayed(): void;

  /**
   * Get Next Item
   * Gets  the next item to play, and then advances the current item.
   * If there is no item available, returns null.
   * It is up to the calling routine to load more items if we run out.
   * @returns {T}
   */
  getNextItem(): T | undefined;

  /**
   * Adds the given item to the scheduler at the given position
   * @param items
   * @param position
   */
  addItems(items: T | T[], position: SchedulePosition): void;
}
